$(document).ready(function () {
    $(".tpl-product-category #product-filters").on("change", function (e) {
        e.stopPropagation();

        let filters = {};
        let activeFilterCount = 0;

        $(".tpl-product-category #product-filters input:checked").each(
            function (index, input) {
                const propertyId = $(input).data("property");
                const propertyValueId = $(input).data("value");

                if (!filters[propertyId]) filters[propertyId] = [];

                filters[propertyId].push(propertyValueId);
                activeFilterCount++;
            }
        );

        $(".tpl-product-category .filter-count").text(
            activeFilterCount > 0 ? activeFilterCount : ""
        );

        $(".tpl-product-category .product-display").each(function (
            index,
            product
        ) {
            let show = true;
            const properties = $(product).data("properties");
            for (let filterId of Object.keys(filters)) {
                if (
                    !properties[filterId] ||
                    !properties[filterId].some((value) =>
                        filters[filterId].includes(value)
                    )
                ) {
                    show = false;
                    break;
                }
            }

            if (show) $(product).fadeIn();
            else $(product).fadeOut();
        });

        $(".tpl-product-category #product-filters .form-check").each(function (
            index,
            filter
        ) {
            const input = $(filter).find("input");
            const propertyId = $(input).data("property");
            const propertyValueId = $(input).data("value");
            const isChecked = input.prop("checked");

            const possibleFilters = Object.assign({}, filters, {
                [propertyId]: [propertyValueId],
            });

            let count = 0;
            $(".tpl-product-category .product-display").each(function (
                index,
                product
            ) {
                const properties = $(product).data("properties");
                let show = true;
                for (let filterId of Object.keys(possibleFilters)) {
                    if (
                        !properties[filterId] ||
                        !properties[filterId].some((value) =>
                            possibleFilters[filterId].includes(value)
                        )
                    ) {
                        show = false;
                        break;
                    }
                }
                if (show) count++;
            });
            if (isChecked || count > 0) $(filter).parent().fadeIn();
            else $(filter).parent().fadeOut();
        });
    });

    $(".tpl-product-category #product-filters .form-check").on(
        "click",
        function (e) {
            e.stopPropagation();
            const input = $(this).find("input");
            input.prop("checked", !input.prop("checked"));
            input.trigger("change");
        }
    );

    $(".tpl-product-category #product-filters").change();
});
